import { render, staticRenderFns } from "./JobMatchingSettingSp.vue?vue&type=template&id=5ed5f626"
import script from "./JobMatchingSettingSp.vue?vue&type=script&lang=js"
export * from "./JobMatchingSettingSp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports